import { schema } from "normalizr";
const appsSchema = new schema.Entity("apps", { idAttribute: "id" });
const appsArray = [appsSchema];
export default appsArray;



// WEBPACK FOOTER //
// ./src/schemas/apps.js